import { useEffect, useState, useContext } from "react";
import EDITMODAL from 'components/editmodal';
import api from "services/api";
import { getAno, getHoje } from "components/formatos";
import { getnome } from "functions/gettabconfig";
import config from 'config';
import SELECT from "components/select";
import { CidadeContext } from "services/cidade";
import './style.css';


function AdminSORTEIO(props) {

  const [loading, setLoading] = useState(false);
  const [mensagem, setMensagem] = useState('');
  const [lcampanhas, setLCampanhas] = useState([]);
  const [idcampanha, setIDCampanha] = useState(-1);
  const [numeroSorteado, setNumeroSorteado] = useState('SORTEANDO...');
  const [sorteando, setSorteando] = useState(false);

  const [sorteado, setSorteado] = useState(false);
  const [mloja, setMLoja] = useState('N');
  const [musuario, setMUsuario] = useState('N');

  const [nomesorteado, setNomeSorteado] = useState('');
  const [nomeestabelecimento, setNomeEstabelecimento] = useState('');
  const [idsorteio, setIDSorteio] = useState('');
  const [dencampanha, setDenCampanha] = useState('');

  const {cod_cidade} = useContext(CidadeContext)
  

  const sortearNumero = () => {
    if (idcampanha < 0) {
      setMensagem('Selecione uma campanha');
      return;
    }
    setSorteando(true);
    setTimeout(() => {
      api.get(`${config.ADM_SORTEIO}/${idcampanha}?cod_cidade=${cod_cidade}&mloja=${mloja}&musuario=${musuario}`)
        .then(response => {
          setSorteando(false);
          setSorteado(true);
          if (response.status === 200) {
            setIDSorteio(response.data.id_sorteio);
            setNomeEstabelecimento(response.data.nom_estabecimento);
            setNomeSorteado(response.data.nom_usuario);
            setDenCampanha(`${response.data.den_campanha}`);
          } else {
          setSorteando(false);
          setSorteado(false);
          setNumeroSorteado('SORTEANDO');
          const errorMessage =response.response.data.erro || 'Erro ao sortear';
          setMensagem(errorMessage);
          console.error(response);
          }
        })
        .catch(error => {
          setSorteando(false);
          setSorteado(false);
          setNumeroSorteado('SORTEANDO');
          const errorMessage = error.response?.data?.erro || 'Erro ao sortear';
          setMensagem(errorMessage);
          console.error(error);
        });
    }, 2000); // Tempo de espera para simular o sorteio
  };
  

  function setCampanha(e){    
    setIDCampanha(e);
  }

  useEffect (()=>{
    setLoading(true);
    api.get(`${config.ADM_CAMPANHA}?cod_cidade=${cod_cidade}`)
    .then(response => {
       setLoading(false);
        if (response.status === 200){
            const l = [];
            l.push({
              "id_campanha": -1,
              "den_campanha": "Selecione a campanha",
              })
              l.push({
                "id_campanha": getAno(),
                "den_campanha": `Todas as campanhas de  ${getAno()}`,
                })
            const sortedData = response.data.sort((a, b) => b.id_campanha - a.id_campanha);
            sortedData.forEach(item => {
              item.den_campanha = `${item.id_campanha} - ${item.den_campanha}`;
            });
            l.push(...sortedData);
            setLCampanhas(l);
        }
    });
    setNumeroSorteado('SORTEANDO');
    setSorteado(false);
  }, [props.isOpen, cod_cidade])


  return <EDITMODAL
    programa={'SORTEIO'}
    isOpen={props.isOpen}
    onRequestClose={props.onRequestClose}
    loading={loading}
    operacao={props.operacao}
    mensagem={mensagem}
    SalvaParametro={props.onRequestClose}
    dcreate={getHoje()}
    ocreate={getnome()}
    dupdate={getHoje()}
    oupdate={getnome()}
    habilitadelete={false}
    habilitabotoes={false}
  >
    <div className="row">
    { !sorteado ? <>    
        <div className="col-md-6">
          <SELECT
          key={'SELECIONACAMPANHA'}
          name={'SELECIONACAMPANHA'}
          SalvaSelect={setCampanha}
          value={idcampanha}
          chave={'id_campanha'}
          descricao={'den_campanha'}
          aoptions={lcampanhas}
          //retornoe={true}
          />
      </div>
      <div className="sorteio-container">    
        <div className={`numero-sorteado ${sorteando ? "sorteando" : ""}`}>
          {numeroSorteado}
        </div>
        <div className="sorteio-texto">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="mloja"
              checked={mloja === 'S'}
              onChange={() => setMLoja(mloja === 'S' ? 'N' : 'S')}
            />
            <label className="form-check-label" htmlFor="mloja">
              Duplica Loja
            </label>
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="musuario"
              checked={musuario === 'S'}
              onChange={() => setMUsuario(musuario === 'S' ? 'N' : 'S')}
            />
            <label className="form-check-label" htmlFor="musuario">
              Repete Usuário
            </label>
          </div>
          </div>
        <button type='button' className="btn btn-primary"
          onClick={()=>sortearNumero()} disabled={sorteando}>
          Sortear
        </button>
      </div>
     </>
     :<>
     <div className="form-group row">
     <label for="Cupom" className="col-sm-2 col-form-label">Cupom</label>
     <div className="col-sm-10">
         <input type="text" value={idsorteio??0} className="form-control" id="Cupom" />
     </div>
    </div>
    <div className="form-group row">
        <label for="Nome" className="col-sm-2 col-form-label">Nome</label>
        <div className="col-sm-10">
            <input type="text" value={nomesorteado??''} className="form-control" id="Nome"  />
        </div>
    </div>
    <div className="form-group row">
        <label for="Estabelecimento" className="col-sm-2 col-form-label">Estabelecimento</label>
        <div className="col-sm-10">
            <input type="text" value={nomeestabelecimento??''} className="form-control" id="Estabelecimento" />
        </div>
    </div>  
    <div className="form-group row">
        <label for="Campanha" className="col-sm-2 col-form-label">Campanha</label>
        <div className="col-sm-10">
            <input type="text" value={dencampanha??''} className="form-control" id="Campanha" />
        </div>
    </div>   
    
    </>
     }

  </div>
  </EDITMODAL>
  
}

export default AdminSORTEIO;